import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { FetchMaxLocationLimit } from "../../../domain/useages/brick-management/fetch-max-distance-location";
import { RemoteFetchMaxLocationLimit } from "../../../data/usecases/brick-management/remote-max-location-limit";
import Endpoints from "../../../domain/endpoints";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchMaxLocationLimitInterface {
  FetchMaxLocationLimitState: FetchState;
  fetchMaxLocationLimit: Function;
}

const initialStates = {
  FetchMaxLocationLimitState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchMaxLocationLimitSlice: StateCreator<
  FetchMaxLocationLimitInterface
> = (set) => ({
  ...initialStates,
  fetchMaxLocationLimit: async (params: FetchMaxLocationLimit.Params) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchMaxLocationLimit = new RemoteFetchMaxLocationLimit(
      `${BASE_URL}${Endpoints.FETCH_MAX_LOCATION_LIMIT}`,
      axiosHttpClient
    );
    let result = await remoteFetchMaxLocationLimit.fetch(params);
    return result;
  },
});
